module.exports = __webpack_public_path__ + "static/media/TheCurseofEelgrassBogBookJacket.08057a6c.jpg";